import { LeadSourceChoiceDto } from '@sr/dto';
import { leadBaseApi } from './api';

export const leadSourceChoicesApi = leadBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLeadSourceChoices: builder.query<LeadSourceChoiceDto[], void>({
      query: () => 'lead/sources',
      keepUnusedDataFor: 0,
    }),
  }),
});
